import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useSettings from '../../../hooks/useSettings';
import { isPresentationsEnabledForTheme } from './presentationFeatureFlags';

/**
 * Redirects to home when the active white-label theme does not include Presentations (e.g. CCC).
 */
export default function PresentationsThemeGate({ children }) {
  const { settings } = useSettings();
  if (!isPresentationsEnabledForTheme(settings.theme)) {
    return <Navigate to="/" replace />;
  }
  return children;
}

PresentationsThemeGate.propTypes = {
  children: PropTypes.node.isRequired,
};
